const OfferDataPrices = [
  {
    title: "Zajęcia indywidualne",
    description: "Stacjonarnie lub online, w tym z native speakerem",
    prices: [
      {duration: "45 min", price: "110 zł"},
      {duration: "60 min", price: "135 zł"}],
  },
  {
    title: "Para",
    description: "Cena za osobę",
    prices: [
      {duration: "45 min", price: "60 zł"},
      {duration: "60 min", price: "75 zł"}],
  },
  {
    title: "3 osoby",
    description: "Cena za osobę",
    prices: [
      {duration: "45 min", price: "50 zł"},
      {duration: "60 min", price: "60 zł"}],
  },
  {
    title: "Grupa 4–6 osób",
    description: "Cena za osobę",
    prices: [
      {duration: "45 min", price: "45 zł"},
      {duration: "60 min", price: "55 zł"},
    ],
  },
];

export default OfferDataPrices;
